import React from "react";
import { createPortal } from "react-dom";
import { IoClose } from "react-icons/io5";

const container = document.querySelector("#custom-modal");

function CustomModal({ children, isOpen, closeModal }) {
  return createPortal(
    <>
      {isOpen && (
        <div className="fixed top-0 left-0 min-h-screen max-h-screen bg-black/20 z-50 w-full backdrop-blur-sm flex justify-center items-center">
          <div className="relative px-8 py-8 bg-[#f5f5f3] border border-[black] rounded-lg overflow-hidden shadow-2xl max-h-screen flex flex-col">
            <span
              onClick={closeModal}
              className="font-Pacifico absolute top-2 right-2 text-white cursor-pointer text-sm px-2 py-[2px] bg-black border-l border-b border-gray-600 rounded-es-lg hover:text-gray-300 hover:bg-gray-700 transition-all"
            >
              {/* Close */}
              <IoClose size={18} />
            </span>
            <div className="flex-1 overflow-y-auto">{children}</div>
          </div>
        </div>
      )}
    </>,
    container
  );
}

export default CustomModal;
